import { render, staticRenderFns } from "./kids_class.vue?vue&type=template&id=6588477e&scoped=true&"
import script from "./kids_class.vue?vue&type=script&lang=js&"
export * from "./kids_class.vue?vue&type=script&lang=js&"
import style0 from "./kids_class.vue?vue&type=style&index=0&id=6588477e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6588477e",
  null
  
)

export default component.exports